import { camelCase } from 'lodash-es';

import { Nullable } from '@rbi-ctg/frontend';
import { IRestaurantNode } from 'generated/rbi-graphql';
import { ServiceMode } from 'state/service-mode/types';
import { StoreProxy } from 'state/store/hooks/types';
import { PosVendors } from 'utils/vendor-config';

export const getPosVendorFromStore = (
  store: StoreProxy | IRestaurantNode,
  serviceMode: Nullable<ServiceMode> = null
): PosVendors | null => {
  if (!store?.pos?.vendor) {
    return null;
  }

  const vendor = camelCase(store.pos.vendor);
  return (serviceMode === ServiceMode.DELIVERY ? vendor.concat('Delivery') : vendor) as PosVendors;
};
